import { defineStyleConfig } from "@chakra-ui/react";

export const tooltipTheme = defineStyleConfig({
	defaultProps: {
		variant: "dark",
	},
	baseStyle: {
		fontWeight: "medium",
		fontSize: "sm",
		py: "8px",
		px: "12px",
		borderRadius: "md",
		textOverflow: "ellipsis",
		maxWidth: "160px",
		margin: "2px",
		zIndex: 5000,
	},
	variants: {
		dark: {
			bg: "neutrals.700",
			color: "text.white",
			boxShadow: "md",
			alignItems: "center",
			".chakra-tooltip__arrow": {
				bg: "var(--chakra-colors-neutrals-700) !important",
				boxShadow: "md",
			},
		},
	},
});
